import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs/Observable';

import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument  } from '@angular/fire/firestore';  // Firebase modules for Database, Data list and Single object

import { Cuenta } from "./cuenta.model";
import { AuthService } from "app/core/auth.service";

import 'rxjs/add/observable/of';

export interface Account {
    id: string,
    nombre: string,
    descripcion: string,
    category: string,
    currency: string,
    uid: string
}


@Injectable()
export class FinanzasCuentasService implements Resolve<any>
{
    user: any;

    onCategoriesChanged: BehaviorSubject<any>;
    onCurrenciesChanged: BehaviorSubject<any>;
    onCoursesChanged: BehaviorSubject<any>;

    // Inject AngularFireDatabase Dependency in Constructor
    /**
     * Constructor
     *
     * @param {HttpClient} _httpClient
     */
    constructor(
        private afs: AngularFirestore,
        private authService: AuthService
        
    ) {
        // Set the defaults
        this.onCategoriesChanged = new BehaviorSubject({});
        this.onCurrenciesChanged = new BehaviorSubject({});
        this.onCoursesChanged = new BehaviorSubject({});
    }

    get uid() {
        return this.authService.user.uid;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Resolver
     *
     * @param {ActivatedRouteSnapshot} route
     * @param {RouterStateSnapshot} state
     * @returns {Observable<any> | Promise<any> | any}
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        return new Promise((resolve, reject) => {

            Promise.all([
                this.getCategories(),
                this.getCuentas(),
                this.getCurrencies()
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    /**
     * Get categories
     *
     * @returns {Promise<any>}
     */
    getCategories(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.afs.collection('categorias')
                .snapshotChanges()
                .subscribe((categoriasSnapshot) => {
                    let _categorias = [];

                    categoriasSnapshot.forEach((categoria: any) => {
                        _categorias.push({
                            id: categoria.payload.doc.id,
                            value: categoria.payload.doc.data().value,
                            label: categoria.payload.doc.data().label
                        });
                    });

                    this.onCategoriesChanged.next(_categorias);
                    resolve(_categorias);
                }, reject);
        });
    }

    /**
     * Get currencies
     *
     * @returns {Promise<any>}
     */
    getCurrencies(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.afs.collection('currencies')
                .snapshotChanges()
                .subscribe((currenciesSnapshot) => {
                    let _currencies = [];

                    currenciesSnapshot.forEach((currency: any) => {
                        _currencies.push({
                            id: currency.payload.doc.id,
                            code: currency.payload.doc.data().code,
                            icon_name: currency.payload.doc.data(). icon_name,
                            label: currency.payload.doc.data().name,
                            unicode_decimal: currency.payload.doc.data().name,
                            unicode_hex: currency.payload.doc.data(). unicode_hex,
                        });
                    });

                    this.onCurrenciesChanged.next(_currencies);
                    resolve(_currencies);
                }, reject);
        });
    }

    /**
     * Get acounts
     *
     * @returns {Promise<any>}
     */
    getCuentas(): Promise<any> {
        return new Promise((resolve, reject) => {

            this.afs.collection('cuentas', ref => ref.where("uid", "==", this.uid))
                .snapshotChanges()
                .subscribe((cuentasSnapshot) => {
                    let _cuentas = [];

                    cuentasSnapshot.forEach((cuenta: any) => {
                        cuenta.payload.doc.data().currency.get().then((currentData) => {
                            _cuentas.push({
                                id: cuenta.payload.doc.id,
                                nombre: cuenta.payload.doc.data().nombre,
                                descripcion: cuenta.payload.doc.data().descripcion,
                                category: cuenta.payload.doc.data().category,
                                currency: currentData.id, // Puedo accesar usando currentData.data().id o el campo a accesar
                                currency_code: currentData.data().code // Puedo accesar usando currentData.data().id o el campo a accesar
                            });
                        })
                    });

                    this.onCoursesChanged.next(_cuentas);
                    resolve(_cuentas);
                }, reject);
        });
    }

    /**
     * Get currency in one account
     * @param id account 
     */
    getCurrencyAccount(id): Observable<any>  {
        return new Observable((observer) => {
            return this.afs.doc('cuentas/' + id).valueChanges().subscribe((account) => {
                let currency = account['currency'].id;
                this.afs.doc('currencies/' + currency).valueChanges().subscribe(e => {
                    observer.next(e);
                })
            });
        })
    }

   

    // Create Student
    AddCuenta(account: Cuenta): Observable<any> 
    {   
        return new Observable((observer) => {
                this.afs.collection('cuentas').add({
                        nombre: account.nombre,
                        descripcion: account.descripcion,
                        category: account.category,
                        currency: this.afs.doc('currencies/' + account.currency).ref,
                        uid: this.uid
                    }
                ).then(function() {
                    observer.next();
                }).catch(function(err) {
                    console.log('Error AddCuenta ', err);
                });
        });
    }

    // updateAccount(account: Cuenta) {

    // }

    /**
     * Update contact
     *
     * @param contact
     * @returns {Promise<any>}
     */
    updateAccount(account: Cuenta): Observable<any>
    {
        return new Observable((observer) => {
            var accountRef = this.afs.collection("cuentas").doc(account.id);
                accountRef.update({
                    nombre: account.nombre,
                    descripcion: account.descripcion,
                    category: account.category,
                    currency: this.afs.doc('currencies/' + account.currency).ref,
                })
                .then(function() {
                    observer.next();
                });
          });
    }

    deleteAccount(account: Cuenta): Observable<boolean> {
        return new Observable((observer) => {
            this.afs.collection("cuentas").doc(account.id).delete().then(() => {
              observer.next();
            });
          })
    }

}
